import React, { Component } from "react";
import { Form, Input } from "antd";
import { connect } from "react-redux";

import style from "./list.module.sass";
import {
  addFroms,
  updateForms
} from "../../../../stateManager/store/forms/action";
import { Http } from "../../../../helpers/axois";
import { pushToast } from '../../../../stateManager/store/toast/actions'
import { setGuideVisible, setStepIndex } from '../../../../stateManager/store/onboarding/action'
import ModalFooter from "../../../../helpers/commonUi/ModalFooter";
import { updateOnboarding } from "../../../../helpers/onboardingHelper";
// import publicIcon from "../../../assets/svg/solo/public_col_ico.svg"
// const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

interface State {
  duplicateErrorMsg?:string;
  formName?: string;
  description?: string;
  soloName?: string;
  selectedFlow?: any;
  selectedJourney?: any;
  isJourneyTypeEdit: boolean;
  selectType?: any;
  selectedAuth: any;
  soloDetails?: any;
  displayErr?: any;
  flowNameFieldDisplayErr?: any;
  selectedFlowDisplayErr?: any;
  editDisplayErr?: any;
  disabledSelection?: any;
}

interface Props {
  onSubmit: (submit: () => void) => void;
  appId?: any;
  getSolo?: () => void;
  getSoloFlows?: any;
  getBpmns?: (guideVisible?: any) => void;
  soloModal?: boolean;
  addFroms?: (data: any) => void;
  editInitialData?: any;
  editable?: boolean;
  updateForms: (data: any) => void;
  pushToast: (data: any) => void;
  currentBranch?: any;
  selectedJourney?: any;
  appVersion?: { currentVersion: boolean, versionId: string };
  editSoloData?: any;
  editType?: string;
  setvisible: any;
  okText: string;
  cancelText: string;
  onOk?: any;
  onCancel?: any;
  userName: string;
  onboardingInfo: any;
  guideVisible: boolean;
  setGuideVisible: (data: boolean) => void;
  setStepIndex?: any;
}
class Bpmn extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      duplicateErrorMsg:"",
      selectedAuth: "",
      selectedJourney: this.props.editType || this.props.selectedJourney || "journey",
      selectType: this.props.editSoloData && (this.props.editSoloData.type || " "),
      isJourneyTypeEdit: ((this.props.editInitialData === undefined) && (this.props.editSoloData === undefined)) && this.props.selectedJourney === null ? true : false,
      formName: this.props.editInitialData && this.props.editInitialData.bpmnName ? this.props.editInitialData.bpmnName : "",
      description: this.props.editInitialData && this.props.editInitialData.description ? this.props.editInitialData.description : ""
    };
    this.props.onSubmit && this.props.onSubmit(this.onSubmit);
  }
  componentDidMount() {
    // this.getSolo()
  }
  onSubmit = () => {
    let { editable, editInitialData } = this.props;
    if ((editable) || (editable && this.state.formName)) {
      if (this.state.selectedJourney === "journey") {
        this.editForm(editInitialData.bpmnId)
      } else {
        // this.soloEditFrom(editSoloData.id)
      }
    } else if (editable) {
      this.setState({ editDisplayErr: "required" })
    }
    if ((!editable && this.state.soloName && (this.state.selectedFlow)) || (!editable && this.state.formName)) {
      this.createForm();
    } else if (!editable && !this.state.soloName && !this.state.selectedFlow) {
      this.setState({ flowNameFieldDisplayErr: "required" })
      this.setState({ selectedFlowDisplayErr: "required" })
    } else if (!editable && !this.state.soloName) {
      this.setState({ flowNameFieldDisplayErr: "required" })
    } else if (!editable && !(this.state.selectedFlow)) {
      this.setState({ selectedFlowDisplayErr: "required" })
    } else if (!editable) {
      this.setState({ displayErr: "required" })
    }
  };

  createForm() {
    const { getBpmns } = this.props
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    if (this.state.selectedJourney === "solo") {
      const soloData = {
        name: this.state.soloName,
        type: this.state.selectedFlow,
        versionId: this.props.appVersion && this.props.appVersion.versionId,
        branchId: currentBranchId
      }
      Http.post(`apps/${this.props.appId}/solo-flows`, soloData).subscribe((formRes) => {
        this.props.pushToast(
          { type: 'success', message: 'solo saved successfully' }
        )
        // this.props.getSolo();
        this.props.getSoloFlows && this.props.getSoloFlows(formRes);
        this.props.setvisible(false)
      }, (err) => {
        this.props.pushToast(
          { type: 'error', message: ((err && err.message) || (err && err.error)) ? err.message ? err.meassage : err.error : 'solo save failed' }
        )
        this.props.setvisible(false)
      })
    } else {
      const data = {
        name: this.state.formName,
        appId: this.props.appId,
        description: this.state.description,
        branchId: currentBranchId
      }
      Http.post('/bpmn', data).subscribe((formRes: any) => {
        this.props.pushToast(
          { type: 'success', message: 'Journey saved successfully' }
        )
        getBpmns && getBpmns(this.props.guideVisible)
        this.props.setvisible(false)
        if (this.props.guideVisible && formRes.length) {
          const stepIndex = this.props.onboardingInfo.stepIndex
          const payload = {
            ...this.props.onboardingInfo,
            stepIndex: stepIndex + 1,
            flowId: formRes[0].bpmn_id
          }
          updateOnboarding(this.props.userName, payload)
        }
      }, (err) => {
        if (err && err.message === "Journey name already exists") {
          this.setState({duplicateErrorMsg: err.message})
        } else {
          this.props.pushToast(
            {type: 'error', message: (err && err.message) ? err.message : 'Journey save failed'}
          )
          this.props.setvisible(false)
        };
      })
    }
  }

  editForm(bpmnId?: string) {
    const data = {
      name: this.state.formName,
      description: this.state.description,
      appId: this.props.appId
    }
    Http.put(`/bpmn/${bpmnId}?appId=${this.props.appId}`, data).subscribe((formRes) => {
      this.props.pushToast(
        { type: 'success', message: 'Journey updated successfully' }
      )
      this.props.getBpmns && this.props.getBpmns();
      this.props.setvisible(false)
    }, (err) => {
      if (err && err.message === "Journey name already exists") {
        this.setState({duplicateErrorMsg: err.message})
      } else {
        this.props.pushToast(
          {type: 'error', message: (err && err.message) ? err.message : 'Journey updation failed'}
        )
        this.props.setvisible(false)
      };
    })
  }

  render() {
    let { editInitialData } = this.props;
    return (
      <div>
        {<Form {...formItemLayout} className={style.app + ' override-content'}>
          <Form.Item
            className="tour_create_journey_name_step"
            validateStatus={(this.state.flowNameFieldDisplayErr && "error") || (this.state.editDisplayErr && "error")}
            help={this.state.flowNameFieldDisplayErr || this.state.editDisplayErr}
            label={<span className={style.labelName}>Assisted Name</span>}>
            <Input
              data-test-id="bpmn_name"
              defaultValue={editInitialData && editInitialData.bpmnName}
              onChange={e => this.setState({ formName: e.target.value, flowNameFieldDisplayErr: "", duplicateErrorMsg: "" })}
              onKeyDown={
                (e: React.KeyboardEvent) => {
                   if(this.props.guideVisible && e.key === 'Tab') {
                    e.preventDefault()
                  }
              }} 
            />
            {this.state.duplicateErrorMsg && <div style={{color:"#EB001B", marginTop:"12px", fontSize:"15px"}}>{this.state.duplicateErrorMsg}</div>}
          </Form.Item>
          <Form.Item className="create_journey_description_step tour_journey_desc" label={<span className={style.labelName}>Description</span>}>
            <Input
              data-test-id="description"
              defaultValue={editInitialData && editInitialData.description}
              onChange={e => this.setState({ description: e.target.value })}
              onKeyDown={
                (e: React.KeyboardEvent) => {
                   if(this.props.guideVisible && e.key === 'Tab') {
                    e.preventDefault()
                  }
              }} 
            />
          </Form.Item>
        </Form>}
        <ModalFooter
          okText={this.props.okText}
          cancelText={this.props.cancelText}
          okCallback={this.props.onOk}
          cancelCallback={this.props.onCancel}
          okClassName="tour_journey_creation"
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentBranch: state.apps.appBranch,
    selectedJourney: state.solo.selectedJourneyInBpmn,
    onboardingInfo: state.onboarding.info,
    guideVisible: state.onboarding.guideVisible,
    userName: state.user.data.user.userName
  }
}

export default connect(
  mapStateToProps,
  { addFroms, updateForms, pushToast, setGuideVisible, setStepIndex }
)(Bpmn);
